import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { DragLayer as DragLayer$1 } from 'react-dnd';
import MuiBox from '@mui/material/Box';
import DragLayerPreview from './DragLayerPreview.js';
import { getGrowOutEffect, getShrinkInEffect } from './styled.js';

const transitionDuration = 225;
let subscribedToOffsetChange = false;
let dragPreviewRef;
const onOffsetChange = (monitor) => () => {
    if (!dragPreviewRef)
        return;
    const offset = monitor.getClientOffset();
    if (!offset)
        return;
    dragPreviewRef.style['transform'] = `translate(${offset.x}px, ${offset.y}px)`;
};
let localItem = null;
let initialOffset = null;
var DragLayer = DragLayer$1((monitor) => {
    if (!subscribedToOffsetChange) {
        monitor.subscribeToOffsetChange(onOffsetChange(monitor));
        subscribedToOffsetChange = true;
    }
    return {
        item: monitor.getItem(),
        componentType: monitor.getItemType(),
        isDragging: monitor.isDragging(),
        offset: monitor.getClientOffset(),
    };
})(class CustomDragLayer extends React__default.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            grow: false,
        };
    }
    componentDidUpdate() {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        dragPreviewRef = this.rootNode;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { isDragging } = nextProps;
        const { grow } = this.state;
        if (!isDragging && localItem && !grow) {
            this.setState({
                grow: true,
            });
            setTimeout(() => {
                localItem = null;
                initialOffset = null;
                this.setState({
                    grow: false,
                });
            }, transitionDuration + 10);
        }
    }
    componentWillUnmount() {
        subscribedToOffsetChange = null;
    }
    render() {
        const { item, isDragging, rtl, offset } = this.props;
        const offsetLeft = this.props.offsetLeft || 0;
        const { grow } = this.state;
        const { columnId, width } = item || {};
        if (columnId) {
            return null;
        }
        if (isDragging && !localItem) {
            localItem = Object.assign(Object.assign({}, item), { width });
        }
        if ((!isDragging || !initialOffset) && localItem === null)
            return null;
        if (!initialOffset) {
            initialOffset = offset;
        }
        const { checked, selectedRowIds, enableCheckboxSelection } = localItem || {};
        const count = Object.keys(selectedRowIds || {}).length || 1;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        return (jsx(MuiBox, Object.assign({ ref: el => (this.rootNode = el), style: {
                position: 'fixed',
                pointerEvents: 'none',
                top: 0,
                left: 0,
                transform: 'translate(0, 0)',
            }, sx: {
                animation: `${grow === true
                    ? getGrowOutEffect(initialOffset, offset, localItem.width, offsetLeft)
                    : isDragging
                        ? getShrinkInEffect(initialOffset, localItem.width, offsetLeft)
                        : ''} ${transitionDuration / 1000}s ease`,
            } }, { children: jsx(DragLayerPreview, Object.assign({}, { count, rtl, enableCheckboxSelection, checked })) })));
    }
});

export { DragLayer as default };
//# sourceMappingURL=DragLayer.js.map
